import React, { useEffect, useContext } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../auth/authProvider";
import { ClaimHelper, StringHelper, TokenHelper } from "../../assets/utils/helpers";
import { AboutAndNews, Contact, Header, KeyFeatures, WhatIsHere, WhyCitiesLove, Footer, CommunityEngagement, CivicTimeline } from "./components/section";
import { GetApplicationSetting, IApplicationSettings } from "../../assets/configuration";

export const Home = () => {
    const auth = useContext(Auth);
    const navigate = useNavigate();
    const applicationSettings: IApplicationSettings = GetApplicationSetting;

    useEffect(() => {
        if (auth.isAuthenticated()) {
            const claim = TokenHelper.getClaims();
            const defaultPage = ClaimHelper.getClaimStringValue("landing_page");
            const redirectUrl = StringHelper.replacePlaceholders(defaultPage, claim);
            navigate(`/${redirectUrl}`);
        }
    }, [auth]);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    return (
        <div className="overflow-x-hidden">
            <Header
                logoSrc="/images/HereAndNowCCT.png"
                title={
                    <>
                        Empower Your <br /> Community
                    </>
                }
                subtitle="Connect with residents through a powerful, easy-to-use platform"
                ctaLabel="Request a Demo Today"
                //ctaHref="https://outlook.office365.com/book/CommunityConnectorPlatform@vinformatix.com"
                ctaHref="#contact"
                headerIconStyle={{ backgroundColor:"#162242", alignContent:"center"}}
            />
            <WhatIsHere serviceSettings={applicationSettings.serviceSettings} />
            <KeyFeatures />
            <WhyCitiesLove />
            <CivicTimeline />
            <CommunityEngagement serviceSettings={applicationSettings.serviceSettings} />
            <AboutAndNews serviceSettings={applicationSettings.serviceSettings} />
            <Contact />
            <Footer serviceSettings={applicationSettings.serviceSettings} />
        </div>
    );
};